import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  observacoesPorItem: {}, // Ex: { "itemId123": "Texto da observação" }
};

const observacoesSlice = createSlice({
  name: 'observacoes',
  initialState,
  reducers: {
    atualizarObservacao: (state, action) => {
      const { idProcessoItem, observacoes } = action.payload;
      state.observacoesPorItem[idProcessoItem] = observacoes;
    },
    carregarObservacoesIniciais: (state, action) => {
      const observacoes = action.payload; // Array de objetos [{ idProcessoItem, observacoes }]
      observacoes.forEach(({ idProcessoItem, observacoes }) => {
        state.observacoesPorItem[idProcessoItem] = observacoes;
      });
    },
    limparObservacoes: (state, action) => {
      delete state[action.payload];
    },
  },
});

export const { atualizarObservacao, carregarObservacoesIniciais, limparObservacoes } = observacoesSlice.actions;

export default observacoesSlice.reducer;
